import { render, staticRenderFns } from "./4XX.vue?vue&type=template&id=391e3309&"
import script from "./4XX.vue?vue&type=script&lang=js&"
export * from "./4XX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports